import styled from "styled-components"

export const StyledMealSection = styled.section`
  // border: 0.8px solid var(--Schemes-Outline-Variant, rgba(0, 38, 58, 0.14));
  // border-radius: var(--spacing_s, 8px);
  // box-shadow: 0px 1px 6px 0px rgba(28, 31, 33, 0.06);
  // overflow: hidden;
`

export const MealSectionCalories = styled.div<{ $hasCal: boolean }>`
  font-size: 14px;
  font-weight: 700;
  color: ${(props) =>
    props.$hasCal
      ? "#1C1F21"
      : "var(--Schemes-Outline, rgba(0, 38, 58, 0.32))"};

  span {
    font-weight: 500;
    font-size: 12px;
  }
`

export const MealSectionTitle = styled(MealSectionCalories)`
  text-transform: uppercase;
  color: rgba(0, 34, 52, 0.84);
  letter-spacing: 0.24px;
  font-size: 12px;
  font-weight: 700;
`

export const MealSectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
